import type { AppMode } from '@iheartjane/types';

// eslint-disable-next-line no-restricted-imports
import type { Store } from '@jane/shared/models';
import type { UserLocation } from '@jane/shared/types';

export const useProductReviewsEnabled = (
  appMode: AppMode,
  userLocation: UserLocation | null,
  currentStore?: Store | null
) => {
  // Product reviews not allowed in Ohio
  if (userLocation?.cityState?.match(/, OH$/)) {
    return false;
  }

  if (appMode === 'default') {
    if (currentStore) {
      return !currentStore.force_disable_reviews;
    } else {
      return true;
    }
  }
  if (currentStore) return currentStore.product_reviews_enabled;
  return true;
};
